import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'

import type {
  RefractoryBondingOption,
  RefractoryClassification,
  RefractoryClassificationGroup,
  RefractoryManufacturer
} from '../types'

const REFRACTORY_CATALOG_FILTER_OPTIONS_QUERY_KEY = 'refractoryCatalogFilterOptions'

export interface RefractoryCatalogFilterOptions {
  manufacturers: RefractoryManufacturer[]
  classifications: RefractoryClassification[]
  classificationGroups: RefractoryClassificationGroup[]
  bondings: RefractoryBondingOption[]
}

export const useRefractoryCatalogFilterOptionsQuery = () =>
  useQuery({
    queryKey: [REFRACTORY_CATALOG_FILTER_OPTIONS_QUERY_KEY],
    queryFn: async (): Promise<RefractoryCatalogFilterOptions> => {
      const [manufacturers, classifications, classificationGroups, bondings] = await Promise.all([
        ApiClient.axiosInstance.get<RefractoryManufacturer[]>(
          '/plants/refractory-product-data-catalog/manufacturers'
        ),
        ApiClient.axiosInstance.get<RefractoryClassification[]>(
          '/plants/refractory-product-data-catalog/classifications'
        ),
        ApiClient.axiosInstance.get<RefractoryClassificationGroup[]>(
          '/plants/refractory-product-data-catalog/classifications/groups'
        ),
        ApiClient.axiosInstance.get<RefractoryBondingOption[]>(
          '/plants/refractory-product-data-catalog/bondings'
        )
      ])

      return {
        manufacturers: manufacturers.data,
        classifications: classifications.data,
        classificationGroups: classificationGroups.data,
        bondings: bondings.data
      }
    },
    staleTime: Infinity
  })
